function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "400px",
    height: "400px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.913
    },
    fill: "#808080",
    d: "M 185.5,-0.5 C 195.167,-0.5 204.833,-0.5 214.5,-0.5C 287.799,7.37734 342.299,43.3773 378,107.5C 389.211,130.356 396.378,154.356 399.5,179.5C 399.5,192.833 399.5,206.167 399.5,219.5C 396.27,242.807 390.437,265.474 382,287.5C 377.483,297.317 371.983,306.983 365.5,316.5C 359.657,323.507 353.657,330.34 347.5,337C 331.857,351.299 315.023,364.132 297,375.5C 285.186,380.603 273.353,385.603 261.5,390.5C 246.255,394.624 230.921,397.624 215.5,399.5C 206.833,399.5 198.167,399.5 189.5,399.5C 189.167,398.167 188.833,398.167 188.5,399.5C 188.167,399.5 187.833,399.5 187.5,399.5C 104.969,390.507 46.9689,348.674 13.5,274C 9.35186,262.776 6.01852,251.276 3.5,239.5C 2.22342,229.68 0.890085,220.013 -0.5,210.5C -0.5,202.833 -0.5,195.167 -0.5,187.5C 5.84122,111.855 43.6746,55.5218 113,18.5C 136.282,8.47213 160.449,2.1388 185.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M 247.5,20.5 C 249.905,21.7682 252.572,22.4349 255.5,22.5C 316.517,43.6843 357.35,85.0176 378,146.5C 393.92,210.533 381.587,268.2 341,319.5C 313.967,349.922 280.8,369.922 241.5,379.5C 236.715,380.509 232.048,381.509 227.5,382.5C 226.167,382.5 224.833,382.5 223.5,382.5C 206.503,383.771 189.503,383.771 172.5,382.5C 94.5468,367.72 43.7134,322.387 20,246.5C 17.9853,235.879 16.4853,225.212 15.5,214.5C 15.3963,200.153 15.7296,185.82 16.5,171.5C 17.3438,168.655 18.0104,165.655 18.5,162.5C 31.7586,102.084 66.0919,58.2505 121.5,31C 128.981,27.59 136.647,24.7566 144.5,22.5C 147.152,22.5905 149.485,21.9238 151.5,20.5C 155.552,19.312 159.552,18.312 163.5,17.5C 168.37,17.3104 173.036,16.6437 177.5,15.5C 201.131,12.92 224.464,14.5867 247.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6b6b6",
    d: "M 177.5,15.5 C 173.036,16.6437 168.37,17.3104 163.5,17.5C 167.9,15.8958 172.566,15.2291 177.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b2b2b2",
    d: "M 247.5,20.5 C 250.495,20.2938 253.162,20.9605 255.5,22.5C 252.572,22.4349 249.905,21.7682 247.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cccccc",
    d: "M 151.5,20.5 C 149.485,21.9238 147.152,22.5905 144.5,22.5C 146.515,21.0762 148.848,20.4095 151.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#818181",
    d: "M 291.5,60.5 C 292.483,64.2984 292.817,68.2984 292.5,72.5C 291.513,77.3054 291.179,82.3054 291.5,87.5C 292.791,87.7373 293.791,87.404 294.5,86.5C 301.083,84.5824 307.75,82.9157 314.5,81.5C 315.5,81.5 316.5,81.5 317.5,81.5C 317.5,82.8333 317.5,84.1667 317.5,85.5C 314.637,92.4237 312.637,99.757 311.5,107.5C 315.269,107.756 318.936,107.423 322.5,106.5C 328.271,105.887 333.604,106.554 338.5,108.5C 334.053,115.73 330.386,123.397 327.5,131.5C 335.516,132.113 343.516,132.946 351.5,134C 352.624,134.249 353.624,134.749 354.5,135.5C 349.198,142.476 343.864,149.476 338.5,156.5C 346.784,159.986 355.118,163.32 363.5,166.5C 357.193,172.472 350.86,178.472 344.5,184.5C 351.788,189.149 359.121,193.816 366.5,198.5C 359.402,203.863 352.069,208.863 344.5,213.5C 351.254,218.877 357.588,224.71 363.5,231C 357.508,234.11 351.175,236.443 344.5,238C 342.187,238.641 340.52,239.974 339.5,242C 344.292,248.963 349.292,255.796 354.5,262.5C 353.624,263.251 352.624,263.751 351.5,264C 343.471,264.651 335.471,265.485 327.5,266.5C 331.671,274.18 335.337,282.18 338.5,290.5C 329.515,291.377 320.515,291.377 311.5,290.5C 311.263,291.791 311.596,292.791 312.5,293.5C 312.294,296.495 312.96,299.162 314.5,301.5C 315.475,304.067 316.142,306.733 316.5,309.5C 317.417,312.005 317.417,314.338 316.5,316.5C 308.108,314.743 299.774,312.743 291.5,310.5C 291.506,319.239 292.173,327.905 293.5,336.5C 292.635,337.583 291.635,337.749 290.5,337C 283.031,332.93 275.364,329.43 267.5,326.5C 266.503,334.475 265.67,342.475 265,350.5C 264.751,351.624 264.251,352.624 263.5,353.5C 256.528,348.364 249.695,343.03 243,337.5C 242.055,337.905 241.388,338.572 241,339.5C 238.314,347.264 235.48,354.931 232.5,362.5C 226.528,356.193 220.528,349.86 214.5,343.5C 209.435,350.616 204.602,357.949 200,365.5C 195.322,358.137 190.656,350.804 186,343.5C 179.703,349.466 173.703,355.8 168,362.5C 167.617,361.944 167.117,361.611 166.5,361.5C 166.59,358.848 165.924,356.515 164.5,354.5C 163.14,348.418 160.807,342.752 157.5,337.5C 150.5,342.833 143.5,348.167 136.5,353.5C 134.577,344.621 133.244,335.621 132.5,326.5C 123.988,329.926 115.655,333.593 107.5,337.5C 107.626,328.491 107.959,319.491 108.5,310.5C 100.046,313.112 91.3795,315.112 82.5,316.5C 84.0124,307.72 86.0124,299.053 88.5,290.5C 79.5061,290.966 70.5061,291.3 61.5,291.5C 65.3633,283.24 69.03,274.907 72.5,266.5C 71.5,266.5 70.5,266.5 69.5,266.5C 69.0825,265.778 68.4158,265.278 67.5,265C 61.1828,264.235 54.8495,263.735 48.5,263.5C 45.0017,263.435 44.5017,262.101 47,259.5C 52.0733,253.683 56.9066,247.683 61.5,241.5C 53.0712,238.148 44.7379,234.648 36.5,231C 43.0094,225.323 49.3428,219.489 55.5,213.5C 48.3418,208.656 41.0085,203.989 33.5,199.5C 40.8237,194.503 48.157,189.503 55.5,184.5C 49.5093,178.677 43.3427,173.011 37,167.5C 36.5172,166.552 36.3505,165.552 36.5,164.5C 45.2937,163.012 53.627,160.346 61.5,156.5C 56.4793,149.765 51.4793,143.099 46.5,136.5C 50.8734,135.248 55.2067,133.914 59.5,132.5C 63.8566,132.414 68.19,132.08 72.5,131.5C 69.5974,123.115 65.9307,115.115 61.5,107.5C 65.97,106.514 70.6367,106.181 75.5,106.5C 79.6344,107.485 83.9677,107.818 88.5,107.5C 85.6487,99.0753 83.6487,90.4086 82.5,81.5C 91.3393,82.8606 100.006,84.8606 108.5,87.5C 107.877,78.4732 107.877,69.4732 108.5,60.5C 116.478,64.3876 124.478,68.0542 132.5,71.5C 133.225,62.4656 134.225,53.4656 135.5,44.5C 136.552,44.3505 137.552,44.5172 138.5,45C 144.466,50.6453 150.799,55.812 157.5,60.5C 160.706,52.0503 164.206,43.7169 168,35.5C 174.29,41.4122 180.123,47.7455 185.5,54.5C 190.082,47.0025 194.916,39.6691 200,32.5C 205.084,39.6691 209.918,47.0025 214.5,54.5C 220.5,48.1667 226.5,41.8333 232.5,35.5C 235.394,42.7877 238.228,50.121 241,57.5C 241.388,58.428 242.055,59.0946 243,59.5C 249.963,54.7077 256.796,49.7077 263.5,44.5C 264.251,45.376 264.751,46.376 265,47.5C 265.9,55.5012 266.733,63.5012 267.5,71.5C 275.233,67.3011 283.233,63.6344 291.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8c8c8",
    d: "M 291.5,60.5 C 291.56,59.9569 291.893,59.6236 292.5,59.5C 293.811,63.9838 293.811,68.3171 292.5,72.5C 292.817,68.2984 292.483,64.2984 291.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6b6b6",
    d: "M 314.5,81.5 C 315.568,80.5655 316.901,80.2322 318.5,80.5C 318.784,82.4147 318.451,84.0813 317.5,85.5C 317.5,84.1667 317.5,82.8333 317.5,81.5C 316.5,81.5 315.5,81.5 314.5,81.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cecece",
    d: "M 292.5,72.5 C 291.897,77.6186 292.564,82.2853 294.5,86.5C 293.791,87.404 292.791,87.7373 291.5,87.5C 291.179,82.3054 291.513,77.3054 292.5,72.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8c8c8",
    d: "M 75.5,106.5 C 70.6367,106.181 65.97,106.514 61.5,107.5C 60.9569,107.44 60.6236,107.107 60.5,106.5C 65.6523,105.186 70.6523,105.186 75.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c4c4c4",
    d: "M 322.5,106.5 C 327.975,105.511 333.642,105.178 339.5,105.5C 339.737,106.791 339.404,107.791 338.5,108.5C 333.604,106.554 328.271,105.887 322.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 215.5,120.5 C 228.471,118.961 236.304,124.628 239,137.5C 241.211,148.88 238.377,158.713 230.5,167C 218.459,172.233 209.959,168.733 205,156.5C 200.199,141.763 203.699,129.763 215.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 187.5,120.5 C 189.833,120.5 192.167,120.5 194.5,120.5C 194.5,136.5 194.5,152.5 194.5,168.5C 191.753,168.813 189.086,168.48 186.5,167.5C 182.272,158.045 177.772,148.711 173,139.5C 172.5,149.161 172.334,158.828 172.5,168.5C 170.167,168.5 167.833,168.5 165.5,168.5C 165.5,152.833 165.5,137.167 165.5,121.5C 168.247,121.187 170.914,121.52 173.5,122.5C 177.728,131.955 182.228,141.289 187,150.5C 187.5,140.506 187.666,130.506 187.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838383",
    d: "M 218.5,128.5 C 225.679,128.163 229.846,131.496 231,138.5C 232.665,146.675 230.832,153.841 225.5,160C 217.755,161.603 213.255,158.436 212,150.5C 209.71,141.641 211.876,134.307 218.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a2a2a2",
    d: "M 59.5,132.5 C 55.2067,133.914 50.8734,135.248 46.5,136.5C 45.9569,136.44 45.6236,136.107 45.5,135.5C 49.9771,133.763 54.6438,132.763 59.5,132.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aeaeae",
    d: "M 18.5,162.5 C 18.0104,165.655 17.3438,168.655 16.5,171.5C 16.3359,168.813 16.5026,166.146 17,163.5C 17.3826,162.944 17.8826,162.611 18.5,162.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e1e1e1",
    d: "M 16.5,171.5 C 15.7296,185.82 15.3963,200.153 15.5,214.5C 14.8338,208.843 14.5005,203.01 14.5,197C 14.3177,188.28 14.9844,179.78 16.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 170.5,199.5 C 182.247,198.124 189.747,203.124 193,214.5C 194.664,224.336 193.331,233.669 189,242.5C 182.364,248.949 174.864,250.115 166.5,246C 162.572,242.312 160.072,237.812 159,232.5C 158.116,225.418 158.449,218.418 160,211.5C 161.963,206.044 165.463,202.044 170.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 213.5,199.5 C 224.051,197.601 231.051,201.601 234.5,211.5C 234.167,212.167 233.833,212.833 233.5,213.5C 231.618,214.093 229.785,214.76 228,215.5C 225.747,208.894 221.247,206.727 214.5,209C 212.622,210.543 211.122,212.376 210,214.5C 209.123,221.249 209.456,227.916 211,234.5C 215.53,241.588 220.863,242.255 227,236.5C 227.495,234.527 227.662,232.527 227.5,230.5C 224.833,230.5 222.167,230.5 219.5,230.5C 219.5,227.833 219.5,225.167 219.5,222.5C 224.833,222.5 230.167,222.5 235.5,222.5C 240.053,241.44 232.72,249.94 213.5,248C 207.378,244.613 203.545,239.446 202,232.5C 198.458,218.613 202.291,207.613 213.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 255.5,199.5 C 267.078,197.702 274.578,202.369 278,213.5C 278.667,220.5 278.667,227.5 278,234.5C 271.987,249.523 262.32,252.523 249,243.5C 244.995,237.67 243.161,231.17 243.5,224C 242.631,213.24 246.631,205.073 255.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfdfdf",
    d: "M 133.5,201.5 C 131.167,201.5 128.833,201.5 126.5,201.5C 126.5,216.833 126.5,232.167 126.5,247.5C 125.504,232.009 125.17,216.342 125.5,200.5C 128.385,200.194 131.052,200.527 133.5,201.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefffe",
    d: "M 133.5,201.5 C 133.5,214.167 133.5,226.833 133.5,239.5C 139.5,239.5 145.5,239.5 151.5,239.5C 151.5,242.167 151.5,244.833 151.5,247.5C 143.167,247.5 134.833,247.5 126.5,247.5C 126.5,232.167 126.5,216.833 126.5,201.5C 128.833,201.5 131.167,201.5 133.5,201.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#838383",
    d: "M 171.5,208.5 C 178.256,206.722 182.756,209.056 185,215.5C 185.667,221.167 185.667,226.833 185,232.5C 179,243.167 173,243.167 167,232.5C 166.333,226.833 166.333,221.167 167,215.5C 168.012,212.798 169.512,210.465 171.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#848484",
    d: "M 257.5,208.5 C 264.778,207.272 269.278,210.272 271,217.5C 272.625,225.613 270.792,232.78 265.5,239C 258.343,241.667 253.843,239.167 252,231.5C 250.902,224.615 251.569,217.949 254,211.5C 255.145,210.364 256.312,209.364 257.5,208.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a5a5a5",
    d: "M 48.5,263.5 C 54.8495,263.735 61.1828,264.235 67.5,265C 68.4158,265.278 69.0825,265.778 69.5,266.5C 62.3022,265.953 55.3022,264.953 48.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6b6b6",
    d: "M 312.5,293.5 C 313.768,295.905 314.435,298.572 314.5,301.5C 312.96,299.162 312.294,296.495 312.5,293.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bfbfbf",
    d: "M 316.5,309.5 C 318.557,311.857 318.89,314.524 317.5,317.5C 316.893,317.376 316.56,317.043 316.5,316.5C 317.417,314.338 317.417,312.005 316.5,309.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cdcdcd",
    d: "M 164.5,354.5 C 165.924,356.515 166.59,358.848 166.5,361.5C 165.076,359.485 164.41,357.152 164.5,354.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a0a0a0",
    d: "M 241.5,379.5 C 241.389,380.117 241.056,380.617 240.5,381C 236.23,382.075 231.897,382.575 227.5,382.5C 232.048,381.509 236.715,380.509 241.5,379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfdfdf",
    d: "M 172.5,382.5 C 189.503,383.771 206.503,383.771 223.5,382.5C 222.391,383.29 221.058,383.79 219.5,384C 213,384.167 206.5,384.333 200,384.5C 190.615,384.698 181.448,384.032 172.5,382.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDefault);
export default __webpack_public_path__ + "static/media/logo_default.79d0aaa7b7672a3d2fada93fc926f409.svg";
export { ForwardRef as ReactComponent };